import type { EncounterData, NpcEncounter, NpcFaction, NpcHullTier, NpcUnit } from "../types";
import encountersJson from "./encounters.json";

const data = encountersJson as EncounterData;

export function loadEncounters(): NpcEncounter[] {
  return data.encounters;
}

export function loadUnits(): NpcUnit[] {
  return data.units;
}

export function getEncounter(id: string): NpcEncounter | undefined {
  return data.encounters.find((e) => e.id === id);
}

export function encountersByFaction(faction: NpcFaction): NpcEncounter[] {
  return data.encounters.filter((e) => e.faction === faction);
}

export function encountersByHullTier(tier: NpcHullTier): NpcEncounter[] {
  return data.encounters.filter((e) => e.hullTier === tier);
}
